module.exports = __webpack_public_path__ + "media/bootstrap-icons/grip-horizontal-a2f604a3.svg";